import { render, staticRenderFns } from "./ModalFooterPagination.vue?vue&type=template&id=4eaa5dd2&scoped=true"
import script from "./ModalFooterPagination.vue?vue&type=script&lang=js"
export * from "./ModalFooterPagination.vue?vue&type=script&lang=js"
import style0 from "./ModalFooterPagination.vue?vue&type=style&index=0&id=4eaa5dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa5dd2",
  null
  
)

export default component.exports